import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ScrollToTop } from './components/ScrollToTop';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2rlp1svyx8nfx">
      <BrowserRouter data-id="element-1" data-mp="2rit1j0zlpmob">
        <ScrollToTop data-id="element-2" data-mp="2mluairb8hvuc" />
        <Routes data-id="element-3" data-mp="2mmcb204xiw82">
          <Route path="/" element={<HomePage data-id="element-5" data-mp="2mnnic9xl2m3x" />} data-id="element-4" data-mp="2mmvkesgikcah" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-7" data-mp="31ayrk56alu0v" />} data-id="element-6" data-mp="2mjzp7bw1w1pq" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-9" data-mp="2wk0a329kipw1" />} data-id="element-8" data-mp="31c9tdzg6grpc" />
          <Route path="*" element={<NotFoundPage data-id="element-11" data-mp="2wiferaffj2x4" />} data-id="element-10" data-mp="2wjqg73lejyl2" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}